import * as styledElements from "./HomePageStyles";
import Image from "next/image";
import { DOCS } from "../../constants/routes";
import { ButtonVariants } from "../common/Button/constants";
import { CADSources, uploadBoardForCad } from "../../reducers/uploadedBoard";
import { InvisibleLink } from "./HomePageStyles";
import Button from "../common/Button";
import { HideIfAboveWidth, ShowIfAboveWidth } from "../../constants/Styles";
import { HAMBURGER_PX } from "../Header/HeaderStyles";

interface HeroProps {
  title: string;
  description: string;
  defaultCadUpload?: CADSources;
}

export default function Hero({
  title,
  description,
  defaultCadUpload,
}: HeroProps) {
  return (
    <div style={{ width: "100%g" }}>
      <ShowIfAboveWidth width={HAMBURGER_PX}>
        <styledElements.Vector>
          <Image
            src={"/images/vector_2.png"}
            alt="pretty gradient"
            width={500}
            height={570}
          />
        </styledElements.Vector>
        <styledElements.Vector inverse>
          <Image
            src={"/images/vector_2.png"}
            alt="pretty gradient"
            width={500}
            height={570}
          />
        </styledElements.Vector>
      </ShowIfAboveWidth>
      <styledElements.Title>{title.toLocaleUpperCase()}</styledElements.Title>
      <ShowIfAboveWidth width={HAMBURGER_PX}>
        <styledElements.DescriptionText>
          {description}
        </styledElements.DescriptionText>
        <styledElements.FloatingImage
          src={"/images/pcb.png"}
          alt="pcb"
          width={579}
          height={419}
        />
      </ShowIfAboveWidth>
      <HideIfAboveWidth width={HAMBURGER_PX}>
        <Image src={"/images/pcb.png"} alt="pcb" width={290} height={210} />
        <div>
          <styledElements.MobileDescriptionText>
            {description}
          </styledElements.MobileDescriptionText>
        </div>
      </HideIfAboveWidth>
      <styledElements.ButtonContainer>
        <InvisibleLink href={uploadBoardForCad(defaultCadUpload)}>
          <Button
            centerText
            label="Order board"
            leftIconProps={{
              src: "/icons/wrench.svg",
              alt: "order-board",
              iconDimension: 24,
            }}
            styleProps={{
              width: "327px",
              height: "56px",
              marginBottom: "1rem",
            }}
          />
        </InvisibleLink>
        <InvisibleLink href={DOCS}>
          <Button
            centerText
            label="Learn how to get started"
            rightIconProps={styledElements.expandIconProps}
            variant={ButtonVariants.SECONDARY}
            styleProps={{
              width: "327px",
              height: "56px",
            }}
          />
        </InvisibleLink>
      </styledElements.ButtonContainer>
    </div>
  );
}
